import { FC } from 'react'
import { ReactComponent as MyExitIcon } from './img/exit.svg'
import IconWrapper, { IconWrapperProps } from './IconWrapper'

type ExitIconProps = IconWrapperProps

export const ExitIcon: FC<ExitIconProps> = ({ className, ...props }) => {
  return (
    <IconWrapper className={className} {...props}>
      <MyExitIcon />
    </IconWrapper>
  )
}
